import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../../Layout/Layout";
import Constants from "../../../../../common/SupplierConstants";
import { SearchField } from "../../../../../Components/formElements/SearchField";

//Serivce
import BankModal from "./BankModal";
import { getBankList } from "../../../../../redux/feature/logistics_app/logisticsSlice";
import logistics from "../../../../../services/logistics_appCommonService";
import toast from "react-hot-toast";
import { Button, Modal } from "react-bootstrap";
import CommonFilterCustomerV2 from "../../../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";

const BankList = () => {
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Finance");
  localStorage.setItem("submenu", "Bank Master");

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [modalFuelShowStatus, setmodalFuelShowStatus] = useState(false);

  let bankData = useSelector((state) => state?.logistics?.bank);

  let bankTable = useSelector((state) => state?.logistics?.bank?.pagination);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [data, setData] = useState();

  const [filterShow, setFilterShow] = useState(false);
  const [getFilter, setFilter] = useState({});

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!selectedRow) return;

    let obj = { bankKey: [selectedRow.bankKey] };

    await logistics.deleteBankMaster(obj).then((item) => {
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "Deleted successfully", {
          duration: 2000,
          position: "top-right",
        });
        dispatch(getBankList({}));
      } else {
        toast.error(item?.message || "Please try again !!");
      }
    });

    setShowConfirm(false);
  };

  const BankInfo = [
    {
      name: "Bank IFSC Code",
      id: "bankKey",
      selector: (row) => row?.bankKey,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.bankKey}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Bank Name",
      id: "bankAccountName",
      selector: (row) => row?.bankAccountName,
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.bankAccountName}</span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Address",
      id: "bankAddress",
      selector: (row) => row.bankAddress,
      cell: (row) => (
        <div>
          <p className="">{row.bankAddress} </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Branch",
      id: "bankBranchName",
      cell: (row) => (
        <div>
          <p className=" ">{row.bankBranchName} </p>
        </div>
      ),
      selector: (row) => row.bankBranchName,
      sortable: true,
      width: "130px",
    },
    {
      name: "City",
      id: "bankCity",
      selector: (row) => row.bankCity,
      cell: (row) => (
        <div>
          <p className=" ">{row.bankCity} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },

    {
      name: "Region",
      id: "bankRegion",
      selector: (row) => row.bankRegion,
      cell: (row) => (
        <div>
          <p className="">{row.bankRegion} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Currency",
      selector: (row) => row.bankCurrency,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.bankCurrency} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Delete",
      cell: (row) => (
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleDeleteClick(row)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "200px",
    },
  ];

  const loadInitialBankData = async () => {
    setData(bankData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getBankList",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    dispatch(getBankList(obj));
    setData(bankData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getBankList",
      module: "",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    setNewPerPage(newPerPage);
    dispatch(getBankList(obj));
    setData(bankData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getBankList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getBankList(obj));
  };

  useEffect(() => {
    loadInitialBankData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getBankList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getBankList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* show Cash request Modal Function */
  const showFuelModal = () => {
    setmodalFuelShowStatus(true);
  };
  const hideModalStatus = () => {
    setmodalFuelShowStatus(false); //hide cash request modal
  };

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getBankList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getBankList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Bank List </h2>
                <p className="subText">Bank Details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={BankInfo}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <Modal
              show={showConfirm}
              onHide={() => setShowConfirm(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Are you sure you want to delete{" "}
                  <b>{selectedRow?.bankAccountName}</b>?
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowConfirm(false)}
                >
                  Cancel
                </Button>
                <Button variant="danger" onClick={confirmDelete}>
                  Delete
                </Button>
              </Modal.Footer>
            </Modal>

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BL</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Bank List</span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => showFuelModal()}
                      >
                        Add New Bank
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={BankInfo}
                          data={data}
                          progressPending={bankData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={bankTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <BankModal show={modalFuelShowStatus} onHide={() => hideModalStatus()} />
    </main>
  );
};

export default BankList;
